/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseServiceUrl } from '../base-service-url';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getVersion } from '../fn/version-resource/get-version';
import { GetVersion$Params } from '../fn/version-resource/get-version';
import { Versions } from '../models/versions';

@Injectable({ providedIn: 'root' })
export class VersionResourceService extends BaseServiceUrl {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getVersion()` */
  static readonly GetVersionPath = '/api/version';

  /**
   * Get Version.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getVersion()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVersion$Response(params?: GetVersion$Params, context?: HttpContext): Observable<StrictHttpResponse<Versions>> {
    return getVersion(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Version.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getVersion$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVersion(params?: GetVersion$Params, context?: HttpContext): Observable<Versions> {
    return this.getVersion$Response(params, context).pipe(
      map((r: StrictHttpResponse<Versions>): Versions => r.body)
    );
  }

}
